import React from 'react';
import { useLabels } from 'wsm-common-data';

const NoImage = () => {
	const labels = useLabels();

	return (
		<div className="vehicle-card__image vehicle-card__image--placeholder vehicle-card__no-image">
			<i
				className="ddc-icon ddc-icon-size-xlarge ddc-icon-images text-muted"
				aria-hidden="true"
			/>
			<span className="text-muted vehicle-card__no-image-label">
				{labels.get('IMAGE_NOT_AVAILABLE')}
			</span>
		</div>
	);
};

export default NoImage;
